import React, { useState } from 'react';
import { Privilege } from '../../api';
import styled from 'styled-components';
import { Delete } from '@material-ui/icons';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { User } from '../Accounts/AccountUsersOverview';
import useHasPrivilege from './useHasPrivilege';
import usersService from '../../services/users';

interface Props {
  user: User;
  onClose: (reload: Boolean) => void;
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

interface ButtonProps {
  selected: boolean;
}

const Icon = styled.div<ButtonProps>`
  width: 24px;
  height: 24px;
  color: ${(props) => (props.selected ? '#707070' : '#F7F7F7')};
`;

const DeleteUser: React.FunctionComponent<Props> = (props) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const enabled = useHasPrivilege(Privilege.WriteUsers);
  const onClick = (event: React.MouseEvent) => {
    if (enabled) {
      event.preventDefault();
      event.stopPropagation();
      setOpen(true);
    }
  };
  const onDelete = async (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (enabled) {
      try {
        await usersService.deleteUser(props.user.id);
        enqueueSnackbar('User ' + props.user?.email + ' has been deleted', {
          variant: 'info',
          autoHideDuration: 3000,
        });
        
        props.onClose(true);
      }
      catch (e) {
        enqueueSnackbar('Failed to delete user ' + props.user?.email, { variant: 'error', autoHideDuration: 3000 })
      }
    }
    setOpen(false);
  };

  const handleClose = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(false);
  };
  return (
    <Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{'Delete run?'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to delete the user with email address '{props.user?.email}'?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No
          </Button>
          <Button onClick={onDelete} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Icon selected={enabled} onClick={onClick} style={{ cursor: 'pointer'}}>
        <Delete style={{ width: '100%', height: '100%' }} />
      </Icon>
    </Container>
  );
};

export default DeleteUser;
